import * as global from "../misc/global"
import { format } from "date-fns";

export function getUnit(unitId) {
    switch (unitId) {
        case 1:
            return "g";
        case 5:
            return "ml";
        case 11:
            return "pieza";
        default:
            return "x";
    }
}

export function getMealName(mealTime) {
    switch (mealTime) {
        case 1:
            return "Desayuno";
        case 2:
            return "Comida";
        case 3:
            return "Cena";
        case 4:
            return "Colacion";
        case 5:
            return "Colacion 2";
        case 6:
            return "Almuerzo";
        default:
            return "x";
    }
}

export function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

export function getFatPctImperial(sex, height, neck, waist, hip) {
    if (sex === 0)
        // men
        return 86.01 * Math.log10(waist - neck) - 70.041 * Math.log10(height) + 36.76;
    //women
    else return 163.205 * Math.log10(waist + hip - neck) - 97.684 * Math.log10(height) - 78.387;
}

export function getFatPctMetric(sex, height, neck, waist, hip) {
    if (sex === 0)
        // men
        return (
            495 / (1.0324 - 0.19077 * Math.log10(waist - neck) + 0.15456 * Math.log10(height)) -
            450
        );
    //women
    else
        return (
            495 /
            (1.29579 -
                0.35004 * Math.log10(waist + hip - neck) +
                0.221 * Math.log10(height)) -
            450
        );
}

export function getCalories(carbs, fats, prots) {
    let cals = (carbs * 4) + (prots * 4) + (fats * 9);
    if (cals === 0)
        cals = null;
    return cals
}

export function formatDate(jsonDate) {
    let date = new Date(jsonDate);
    return format(date, global.dateFormat, { locale: global.locale });
}

export function getYesNo(boolVal) {
    return boolVal ? "Si" : "No"
}

export function getProgressType(type) {    
    switch (type) {
        case 1:
            return "Inicial";//Initial
        case 2:
            return "Reinicio";//ReStarted
        case 3:
            return "No hizo dieta";//DietNotFollowed
        case 4:
            return "Continua";//ContinueRound
        case 5:
            return "Recuperaci�n";//RecoverCycle
        case 6:
            return "Limite alcanzado"; //TopStatsAchieved
        case 7:
            return "Manual";//Manual
        default:
            return "x";
    }
}